import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

import { ButtonModule, IconModule } from '@hglobal/fin-ui';
import { TranslateModule } from '@ngx-translate/core';

import { StatusIconComponent, WalletCardEmptyComponent } from '@kr/components';
import { WalletCard } from '@kr/models';

@Component({
  selector: 'kr-delete-wallet-success',
  imports: [ButtonModule, IconModule, TranslateModule, WalletCardEmptyComponent, StatusIconComponent],
  templateUrl: './delete-wallet-success.component.html',
  styleUrl: './delete-wallet-success.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DeleteWalletSuccessComponent {
  wallet = input<WalletCard>();

  closed = output<void>();
}
